import { ComponentFactory, ComponentFactoryResolver, ComponentRef, ViewContainerRef } from '@angular/core';
import { PassKeyAuthenticateFormComponent } from './pass-key-authenticate-form.component';

class PassKeyAuthenticateFormSession implements com.ts.mobile.sdk.UIFormSession{
  clientContext: object;
  actionContext: object;
  formId: string;
  payload: object;

  submitHandler: any;
  submitBlock: (payload: object) => void;
  resolver: ComponentFactoryResolver;
  viewContainerRef: ViewContainerRef;
  passKeyAuthenticateFormComponent: ComponentRef<PassKeyAuthenticateFormComponent>;
  username: any;

  constructor(formId: string, payload: object) {

  }
  startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {
    console.log('PassKeyAuthenticateFormSession Started');
    this.username =  clientContext['userID'];

    this.setupForm.call(this);
    this.clientContext = clientContext;
    this.actionContext = actionContext;
    this.resolver = (clientContext as any).resolver;
    this.viewContainerRef = (clientContext as any).viewContainerRef;

    console.log('PassKeyAuthenticateFormSession Ended');
  }
  endSession(): void {
    console.log('PassKeyAuthenticateFormSession: ' + this.formId);
    this.setAsScreen.call(this);
  }

  promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
    console.log('PassKeyAuthenticateFormSession: ' + this.formId);
    const self = this;
    self.viewContainerRef.clear();

    const factory: ComponentFactory<PassKeyAuthenticateFormComponent> =
    self.resolver.resolveComponentFactory(PassKeyAuthenticateFormComponent);
    self.passKeyAuthenticateFormComponent = self.viewContainerRef.createComponent(factory);

    // const journeyPayload = this.payload as JourneyPayload;
    // const action = journeyPayload.actions[0] as ActionsInPayload;

    return new Promise((resolve, reject) => {
      self.submitBlock = (payload: object) => {
        try {
          resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));
          self.submitBlock = null;
        } catch (e) {

        }
      };
    });
  }

  onContinue(payload: object): void {
    console.log('PassKeyAuthenticateFormSession ' + this.formId + ' payload:', payload);
  }
  onError(payload: object): void {
    const errorPayload = payload as JourneyPayload;
  }

  handleNext(e){
   this.submitBlock({
        action: 'submit',
        webauthntoken: null,
        error: e
    });
  }

//  passkeyAuthenticate(){
//     const self = this;

//     (window as any).tsPlatform.webauthn.isPlatformAuthenticatorSupported().then((results) => {

//         if (results){
//          (window as any).tsPlatform.webauthn.authenticate.modal(this.username).then((data3) => {
//          this.submitBlock({
//             action: 'submit',
//             webauthntoken: data3
//         });

//         }).catch((error1) => {
//           console.log('authenticate modal failure defaulting to pwd');
//           this.handleNext.call(self);
//          });
//         }
//         else{
//           console.log('platform support is false, defaulted to pwd');
//           this.handleNext.call(self);
//         }
//     }).catch((error) => {
//         console.log('platform support api failed, defaulted to pwd');
//         // if business wants cross device, call crossDeviceLoginFlow
//         this.handleNext.call(self);
//     });
//   }

   async passkeyAuthenticate(){
    console.log('passkeyAuthenticate start');
    try {
       try {
       const res = await (window as any).tsPlatform.webauthn.authenticate.modal();
       if (res){
          console.log('passkeyAuthenticate res', res);
          this.submitBlock({
            action: 'submit',
            webauthntoken: res
          });
        }
        else{
          this.submitBlock({
            action: 'submit',
            webauthntoken: null,
            error: 'authenticate modal failure',
            failedreason: 'failed'
          });
        }
       }
       catch (e){
           this.submitBlock({
            action: 'submit',
            webauthntoken: null,
            error: e,
            failedreason: 'user cancelled'
          });
       }
    }
    catch (e){
        this.submitBlock({
          action: 'submit',
          webauthntoken: null,
          error: e,
          failedreason: 'failed'
        });
    }

  }

  async setupForm(){
     await this.passkeyAuthenticate.call(this);
     // $.get('password.html', () => {
        //  $(self.clientContext.uiContainer).html(data);

        //  $('#passwordSubmit').on('click', () => {
        //   this.handleNext.call(self);
        //   });

        //  $('#passkeyAuthenticate').on('click',() =>  {
        //   this.passkeyAuthenticate.call(self);
        //   });

        //  $('#custom-password-authenticator_cancel-button').on("click", () => {
        // const escapeOptions = self.actionContext.getEscapeOptions();
        // const qrlogin = escapeOptions.filter(option => option.getId() === 'qrlogin')[0];
        // const cancelOption = escapeOptions.filter(option => option.getId() === 'escape_1')[0];

       // com.ts.mobile.sdk.FormInput.createFormCancellationRequest();

        // });

        //  const showInModal = self.payload.showInModal;
        //  if (showInModal && showInModal === true) {
        //   this.setAsModal.call(self);
        //   }
      // });
  }

  setAsModal() {
      // const container = this.clientContext.uiContainer;
      // $(container).addClass('modal-style');
      // $('#input-password-screen').addClass('modal-content');
      // $('#input-password-screen-content').removeClass('bordered');
    }

  setAsScreen() {
      // const container = this.clientContext.uiContainer;
      // $(container).removeClass('modal-style');
      // $('#input-password-screen').removeClass('modal-content');
      // $('#input-password-screen-content').addClass('bordered');
  }

}

interface JourneyPayload {
  actions: ActionsInPayload[];
  stat: string;
  code: string;
  flow: string;
  recaptchastatus: string;
  loginhint: string;
}

interface ActionsInPayload {
  [key: string]: any;
}

export default PassKeyAuthenticateFormSession;
